import { useCallback, useState } from 'react';

export const useDiscountsMatrix = () => {
  const [discounts, setDiscounts] = useState([]);

  const handleValidateDiscounts = () => {
    for (let i = 0; i < discounts.length - 1; i++) {
      if (discounts[i].maxQuantity >= discounts[i + 1].minQuantity) {
        return false;
      }
    }
    return true;
  };

  const handleAddDiscount = useCallback(() => {
    const isFirstDiscount = discounts.length === 0;

    const newDiscount = isFirstDiscount
      ? {
          minQuantity: 0,
          maxQuantity: null,
          discount: 0,
          type: 'above'
        }
      : {
          minQuantity: 0,
          maxQuantity: 0,
          discount: 0,
          type: 'between'
        };

    setDiscounts((prev) => {
      if (isFirstDiscount) {
        return [...prev, newDiscount];
      }

      const lastElement = prev[prev.length - 1];
      return [...prev.slice(0, prev.length - 1), newDiscount, lastElement];
    });
  }, [discounts.length]);

  const handleRemoveDiscount = useCallback((index) => {
    setDiscounts((prev) => {
      const newDiscounts = [...prev];
      newDiscounts.splice(index, 1);

      if (newDiscounts.length > 0) {
        newDiscounts[newDiscounts.length - 1].type = 'above';
        newDiscounts[newDiscounts.length - 1].maxQuantity = null;

        for (let i = 0; i < newDiscounts.length - 1; i++) {
          newDiscounts[i].type = 'between';
        }
      }

      return newDiscounts;
    });
  }, []);

  const handleDiscountChange = useCallback((index, field, value) => {
    const numericValue = parseFloat(value);
    setDiscounts((prev) => {
      const newDiscounts = [...prev];
      const current = { ...newDiscounts[index] };

      newDiscounts[index] = {
        ...current,
        [field]: numericValue
      };

      return newDiscounts;
    });
  }, []);

  return {
    discounts,
    setDiscounts,
    handleValidateDiscounts,
    handleAddDiscount,
    handleRemoveDiscount,
    handleDiscountChange
  };
};
